export const squashIdIntoValue = (idValuePair) => ({ ...idValuePair.value, id: idValuePair.id });


// WEBPACK FOOTER //
// ./src/js/actions/utils.js